<template>
	<div class="videolist">
		<div class="breadcrumb">角色列表</div>
		<div class="searchBtn" style="border:none;display:flex">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>添加</el-button>
			<el-button size='small' type="warning" @click="edit" plain>编辑</el-button>
			<el-button size='small' type="danger" @click="del" plain>删除</el-button>
			<div class="topinput">
				<input type="text" v-model="roleName" class="el-input__inner" placeholder="角色名称" @keyup.enter="search_mine">
			</div>
			<div class="topinput">
				<input type="text" v-model="roleDesc" class="el-input__inner" placeholder="角色描述" @keyup.enter="search_mine">
			</div>
			<div class="topinput" style="margin-right:15px">
				<el-select v-model="roleStatus" placeholder="请选择角色状态" style="width:100%">
				    <el-option
				      	v-for="item in options"
				      	:key="item.value"
				      	:label="item.label"
				      	:value="item.value">
				    </el-option>
			  	</el-select>
		  	</div>
		  	<el-button type="primary" @click="search_mine">搜索</el-button>
	    </div>
	    <el-table ref="multipleTable" :data="tableData3" highlight-current-row  tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
		    <el-table-column prop="id" label="ID"></el-table-column>
		    <el-table-column prop="roleName" label="角色名称"></el-table-column>
		    <el-table-column prop="roleDesc" label="角色描述"></el-table-column>
		    <el-table-column prop="status" label="角色状态">
		    	<template slot-scope="scope">
		    		{{scope.row.status==1?'有效':'无效'}}
		    	</template>
		    </el-table-column>
		    <el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建时间"></el-table-column>
		</el-table>
	  	<div style="margin-top: 20px">
	    	<div style="float:right">
			    <el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
			</div>
		</div>

		<!-- 添加角色列表弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" ref="ruleForm" status-icon label-width="120px">
      			<el-form-item label="角色名称">
				    <el-input v-model="ruleForm.roleName"></el-input>
				</el-form-item>
				<el-form-item label="角色描述">
				    <el-input type="textarea" v-model="ruleForm.roleDesc" style="width:80%" :rows="4"></el-input>
			  	</el-form-item>
				<el-form-item label="角色状态" style="margin-bottom:10px">
				    <el-radio-group v-model="ruleForm.status">
				      	<el-radio :label="1">有效</el-radio>
				      	<el-radio :label="0">无效</el-radio>
				    </el-radio-group>
			  	</el-form-item>
		        <el-form-item label="权限配置">
		        	<el-tree
					  	:data="menulistData"
					  	show-checkbox
					  	node-key="id"
					  	ref="tree"
					  	:default-expanded-keys="[]"
					  	:default-checked-keys="roleConfigurationid"
					  	:props="defaultProps">
					</el-tree>
		        </el-form-item>
      		</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit">确 定</el-button>
		    </span>
    	</el-dialog>
	</div>
</template>
<script>
export default {
  	mounted() {
  		this.init(); 	
  	},
  	data() {
    	return {
    		pageNum: 1,
		    limit: 10,
		    totalPage: 10,
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
	      	tableData3: [],
	      	dialogVisible: false,
	      	ruleForm: {
      		},
      		roleName:'',
      		roleDesc:'',
      		roleStatus:'',
      		options: [
      			{value: '0',label: '不限'}, 
      			{value: '1',label: '无效'}, 
      			{value: '2',label: '有效'}, 
      		],
	        defaultProps: {
	          	children: 'submenu',
	          	label: 'menuName'
	        },
	        menulistData:[],
      		currentRow:'',
      		roleConfigurationid:[]
	    };
  	},
  	methods:{
  		init(){//视频列表
  			var params = {
        		pageNum: this.pageNum,
        		limit: this.limit,
        		roleName:this.roleName,
        		roleDesc:this.roleDesc,
        		roleStatus:this.roleStatus,
        		type:0
      		};
      		this.$get("/authorityManagement/getManageRoleList", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.tableData3 = res.data.list;
            		this.totalPage = res.data.total;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
        	.catch(() => {
          		console.log();
        	});
  		},
  		handleCurrentChange(val) {
	      	if (val) {
	        	this.currentRow = val;
	      	}
	    },
  		menulist(){
      		this.$get("/authorityManagement/getManageMenuTree")
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
            		this.menulistData = res.data;
          		} else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
  		},
  		//当前页数
	    handleCurrentChangePage(val) {
	    	this.pageNum = val;
	      	this.init()
	    },
  		add(row){
  			this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	      		this.ruleForm={
	      		}
	      		this.roleConfigurationid=[]
	        	this.$refs["ruleForm"].resetFields();
	      	}
	      	this.currentRow='';
	      	this.dialogVisible = true;
	      	this.menulist();
  		},
	    edit(){
	    	console.log(this.currentRow)
	      	if (this.currentRow.id) {
	      		var roleConfiguration = this.currentRow.roleConfiguration;
	      		this.roleConfigurationid=roleConfiguration.split(",");
	      		this.ruleForm=this.currentRow;
	      		this.menulist();
	      		this.dialogVisible = true;
	      	} else {
	        	this.dialogVisible = false;
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    },
	    del(){
	    	var that = this;
	      	if (that.currentRow.id) {
	        	that.$confirm("确定要删除吗?", "提示", {
		            confirmButtonText: "确定",
		            cancelButtonText: "取消",
		            type: "warning"
	          	})
	          	.then(() => {
	            	that.$post("/authorityManagement/delManageRole",JSON.stringify(that.currentRow))
	              	.then(function(res) {
	                	console.log(res);
	                	if (res.code == 0) {
	                  		console.log(" 删除成功 ");
	                  		that.$message({
	                    		message: "删除成功",
	                    		type: "success"
	                  		});
	                  		that.currentRow='';
	                  		that.pageNum = 1;
	                  		that.init();
	                  		that.dialogVisible = false;
	                	} else {
	                  		that.errorMsg("操作失败");
	                	}
	              	})
	              	.catch(function(err) {
	                	console.log(err);
	              	});
	          	})
	          	.catch(() => {});
	      	} else {
		        that.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    },
	    handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	        	this.ruleForm={
			        
		      	}
	      	}
	      	done();
	    },
	    search_mine(){
	    	this.pageNum=1;
	    	this.init()
	    },
	    onSubmit(){
	    	if(!this.ruleForm.roleName){
	    		this.$message({
            		message: '请输入角色名称',
            		type: "warning"
          		});
          		return false;
	    	}else if(this.ruleForm.status==undefined){
	    		this.$message({
            		message: '请选择角色状态',
            		type: "warning"
          		});
          		return false;
	    	}

	    	this.ruleForm.roleConfiguration=(this.$refs.tree.getCheckedKeys()).join();
	    	console.log(this.ruleForm.roleConfiguration)
	    	//return false
	    	this.$refs.ruleForm.validate(valid => {
	          	if (valid) {
	            	this.loading = true;
	            	this.$post("/authorityManagement/addManageRole", JSON.stringify(this.ruleForm))
	              	.then(res => {
	                	this.loading = false;
	                	if (res.code == 0) {
	                  		this.$message({
	                    		message: this.ruleForm.id?"编辑成功":"添加成功",
	                    		type: "success"
	                  		});		                  		
	                  		this.$refs.ruleForm.resetFields();
	                  		this.currentRow='';
	                  		this.pageNum = 1;
	                  		this.init();
	                  		this.dialogVisible = false;
	                	} else {
	                  		this.$message({
	                    		message: res.message,
	                    		type: "warning"
	                  		});
	                  		return false;
	                	}
	              	})
	              	.catch(() => {
	                	this.loading = false;
	              	});
	          	} else {
	            	console.log("error submit!!");
	            	return false;
	          	}
	    	});
	    }
  	}
}
</script>
<style scoped>
.el-input {
  	width: 80%;
}
.topinput{
	position: relative;
	margin-left: 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/views/authorityManagement/roleList.vue